import { Appointment } from '@myapp/contract'
import { ChevronRight, Navigation } from 'lucide-react'

interface Props {
  appointments: Appointment[]
  onAppointmentClick: (appointmentId: string) => void
}

function formatTime(isoDate: string): string {
  const d = new Date(isoDate)
  const h = String(d.getHours()).padStart(2, '0')
  const m = String(d.getMinutes()).padStart(2, '0')
  return `${h}:${m} Uhr`
}

function buildAddress(ext: NonNullable<Appointment['workOrder']>['external'] | undefined): string {
  return [ext?.veAdresse, ext?.hauseingang, ext?.gebaeude].filter(Boolean).join(', ') || '—'
}

export const AppointmentDepartureReminderBanner = ({ appointments, onAppointmentClick }: Props) => {
  if (appointments.length === 0) return null

  return (
    <div className="flex flex-col gap-1.5 px-3 py-2 bg-amber-50/50 border-b border-amber-100">
      <span className="text-[11px] font-medium text-amber-500 uppercase tracking-wide">
        Abfahrt nachtragen
      </span>
      {appointments.map((appointment) => (
        <div
          key={appointment.id}
          className="flex items-center gap-2.5 bg-white rounded-lg shadow-sm border border-amber-200 border-l-4 px-3 py-2 cursor-pointer hover:shadow-md hover:-translate-y-0.5 transition-all duration-200 select-none"
          style={{ borderLeftColor: '#F59E0B' }}
          onClick={() => onAppointmentClick(appointment.id)}
        >
          <Navigation size={15} color="#F59E0B" className="shrink-0" />
          <div className="flex-1 min-w-0">
            <p className="text-sm font-semibold text-gray-800 truncate leading-tight">
              {buildAddress(appointment.workOrder?.external)}
            </p>
            <p className="text-xs text-gray-500 leading-tight mt-0.5">
              {formatTime(appointment.plannedStart)}
            </p>
          </div>
          <ChevronRight size={15} className="shrink-0 text-gray-400" />
        </div>
      ))}
    </div>
  )
}
